import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FontSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-font-single-select-edit-control",
    templateUrl: "../../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class FontSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {

    private static fontMap: any;

    /**
     * Maps a font name to the css font-family values
     */
    static mapFontFamily(fontName: string): string[] {
        FontSingleSelectEditControlComponent.initFontMap();
        return fontName ? FontSingleSelectEditControlComponent.fontMap[fontName] : [];
    }

    private static initFontMap(): void {
        if (FontSingleSelectEditControlComponent.fontMap) {
            return;
        }

        FontSingleSelectEditControlComponent.fontMap = {};

        FontSingleSelectEditControlComponent.fontMap["Arial"] = ["Arial", "Helvetica", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Arial Black"] = ["\"Arial Black\"", "Gadget", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Calibri"] = ["Calibri", "Candara", "\"Segoe UI\"", "Arial", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Candara"] = ["Candara", "Calibri", "\"Segoe UI\"", "Arial", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Comic Sans MS"] = ["\"Comic Sans MS\"", "cursive", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Courier New"] = ["\"Courier New\"", "Courier", "monospace"];
        FontSingleSelectEditControlComponent.fontMap["Georgia"] = ["Georgia", "serif"];
        FontSingleSelectEditControlComponent.fontMap["Impact"] = ["Impact", "Charcoal", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Lucida Console"] = ["\"Lucida Console\"", "Monaco", "monospace"];
        FontSingleSelectEditControlComponent.fontMap["Lucida Sans Unicode"] = ["\"Lucida Sans Unicode\"", "\"Lucida Grande\"", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Palatino Linotype"] = ["\"Palatino Linotype\"", "\"Book Antiqua\"", "serif"];
        FontSingleSelectEditControlComponent.fontMap["Segoe UI"] = ["\"Segoe UI\"", "Arial", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Tahoma"] = ["Tahoma", "Geneva", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Times New Roman"] = ["\"Times New Roman\"", "Times", "serif"];
        FontSingleSelectEditControlComponent.fontMap["Trebuchet MS"] = ["\"Trebuchet MS\"", "Helvetica", "sans-serif"];
        FontSingleSelectEditControlComponent.fontMap["Verdana"] = ["Verdana", "Geneva", "sans-serif"];
    }

    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData();
    }

    override buildData(): void {
        FontSingleSelectEditControlComponent.initFontMap();
        this.data = Object.keys(FontSingleSelectEditControlComponent.fontMap).map(font => ({label: font, value: font}));
    }
}
